export default "__VITE_ASSET__Bzun80an__"